import findCheapestTourV2PurchasableOption from './findCheapestTourV2PurchasableOption'

interface CheapestOfTourV2Offer {
  cheapestDeparture?: Tours.V2OfferDeparture
  cheapestPurchasableOption?: Tours.V2OfferPurchasableOption
  cheapestVariation?: Tours.V2OfferVariation
}

export default function findCheapestOfTourV2Offer(
  offer: Tours.V2Offer | Tours.V2OfferSummary,
  variationId?: Tours.V2OfferVariation['id'],
): CheapestOfTourV2Offer {
  const cheapestPurchasableOption = findCheapestTourV2PurchasableOption(offer, variationId)

  if (!cheapestPurchasableOption) {
    return {
      cheapestDeparture: undefined,
      cheapestPurchasableOption: undefined,
      cheapestVariation: undefined,
    }
  }

  const cheapestDeparture = offer.departures[cheapestPurchasableOption.fkDepartureId]

  const cheapestVariation = offer.variations[cheapestDeparture.fkVariationId]

  return {
    cheapestDeparture,
    cheapestPurchasableOption,
    cheapestVariation,
  }
}
